import { connect } from 'react-redux';
import RecyclingOrders from './RecyclingOrders';
import {
  closeZDVL,
  getZDVL,
  getZDVLAccept,
  getZDVLClear,
  getZDVLDecline,
  getZDVLRolls,
  getZDVLRollsFail,
  getZDVLSend,
  ridZDVLRolls,
  tieZDVLRolls,
  updateZDVL,
  getZDVLSendNotice,
  updateZDVLModalClose
} from '../../store/actions/zdvl';
import { deleteReadyProducts } from '../../store/actions/correctionReadyProducts';
import { modalErrorOpen } from '../../store/actions/modalError';
import { getReportCreateNew } from '../../store/actions/report';
import { saveTask, deleteTaskZdvlLine } from '../../store/actions/task';

const mapStateToProps = ({
  zdvlReducer,
  tabsReducer,
  userReducer,
  semiProductsReducer,
  taskReducer,
  settingsReducer
}) => ({
  zdvlReducer,
  tabsReducer,
  userReducer,
  semiProductsReducer,
  taskReducer,
  settingsReducer
});
const mapDispatchToProps = {
  closeZDVL,
  deleteReadyProducts,
  deleteTaskZdvlLine,
  getReportCreateNew,
  getZDVL,
  getZDVLAccept,
  getZDVLClear,
  getZDVLDecline,
  getZDVLRolls,
  getZDVLRollsFail,
  getZDVLSend,
  modalErrorOpen,
  ridZDVLRolls,
  saveTask,
  tieZDVLRolls,
  updateZDVL,
  getZDVLSendNotice,
  updateZDVLModalClose
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecyclingOrders);
